import { Card, CardContent } from "@/components/ui/card"
import { tStats } from "@/features/staff/stats/format"

/**
 * Two empties, two sentences.
 *
 * A restaurant that has never cut a till has no trend at ANY range and should be
 * pointed at the register. One that simply has no closes inside this window
 * should be pointed at a longer range. Telling the first group to "try a longer
 * range" sends them looking for data that does not exist yet.
 */
export function StatsEmptyState({ hasClosedShifts }: { hasClosedShifts: boolean }) {
  return (
    <Card density="compact" data-testid="stats-empty">
      <CardContent className="space-y-1 py-6 text-center">
        <p className="text-sm font-medium">
          {tStats(hasClosedShifts ? "empty.no_data_title" : "empty.no_shifts_title")}
        </p>
        <p className="text-sm text-muted-foreground">
          {tStats(hasClosedShifts ? "empty.no_data_body" : "empty.no_shifts_body")}
        </p>
      </CardContent>
    </Card>
  )
}
